import { createContext } from "react";

type TileContextValue = {
  titleId: string;
  descriptionId: string;
};

export const TileContext = createContext<TileContextValue | undefined>(undefined);
TileContext.displayName = "TileContext";
